import React, { useState, useCallback, useEffect } from 'react';

const testimonials = [
  {
    image: '/images/gallery/rugs/Rug216_MarlaPeterson.jpg',
    quote: '\u201cA new dimension of art brings warmth and color to my living room floor!\u201d',
    author: 'Marla P.',
  },
  {
    image: '/images/gallery/rugs/Rug115_Pendletonlivingroom_1400x1189.jpg',
    quote: '\u201cIt\u2019s perfect!\u201d',
    author: 'Steph C.',
  },
  {
    image: '/images/gallery/rugs/Rug_livingroom_1400x1120.jpg',
    quote: '\u201cOur living room came alive when we brought our new rug home. We love it!\u201d',
    author: 'Beth M.',
  },
  {
    image: '/images/gallery/rugs/CarolynKalishrug228.1_1400x1050.jpg',
    quote: '\u201cI LOVE this rug. Perfect for the space by our kitchen table. You do beautiful work!\u201d',
    author: 'Carolyn K.',
  },
  {
    image: '/images/gallery/rugs/Rug_piano8x10_1400x1120.jpg',
    quote: '\u201cI put one of Kathy\u2019s smaller rugs on our piano bench, and it\u2019s allowing me to play longer and more often than ever! Never has playing the piano been so comfortable.\u201d',
    author: 'Eric S.',
  },
  {
    image: '/images/gallery/rugs/WHWrug230_dog.jpg',
    quote: '\u201cIt\u2019s MY rug. The cat can have the bag.\u201d',
    author: 'Luke the dog',
  },
  {
    image: '/images/gallery/rugs/CarolBarsottirug_1400x1147.jpg',
    quote: '\u201cWe have really enjoyed our new rug created by Kathy. It offers so much rich color and texture to the room, and we love that it is made with Pendleton<sup>&copy;</sup> woolen mill ends. The quality of Kathy\u2019s weaving and finishing is excellent!\u201d',
    author: 'Carol B.',
  },
  {
    image: '/images/gallery/rugs/Luckysrugfeet_1400x1004.jpg',
    quote: '\u201cThis little one is genuinely grateful for Kathy\u2019s rug, a comfortable, warm place for these small feet. At a young age, the kid already has an appreciation for the fine craft of a local artisan.\u201d',
    author: 'Dawn B.',
  },
  {
    image: '/images/gallery/rugs/KathyOSullivan_rug137_1400x1277.jpg',
    quote: '\u201cI think this rug is perfect and I would like another one just like it for my kitchen!\u201d',
    author: "Kelly O\u2019S.",
  },
  {
    image: '/images/gallery/rugs/KellyOSullivankitchen_rug188.jpg',
    quote: '\u201cKathy at Windy Hill Weavers turns scraps from a local institution, Pendleton<sup>&copy;</sup> Mill, into works of art. For me, these rugs make my home feel warm and cozy. Thank you Kathy for making me such lovely works.\u201d',
    author: "Kelly O\u2019S.",
  },
  {
    image: '/images/testimonials/MelissaHammock.jpg',
    quote: '\u201cOur new rug is beautifully handmade, a wonderful addition to our home!\u201d',
    author: 'Melissa H.',
  },
  {
    image: '/images/gallery/rugs/ShirleyBishop_bathroomrug.jpg',
    quote: '\u201cKathy\u2019s colorful rug goes perfectly in our guest bathroom. We get compliments on it all the time!\u201d',
    author: 'Shirley B.',
  },
  {
    image: '/images/gallery/rugs/ShaneAndrewsbedroom_rug322_square.jpg',
    quote: '\u201cWe are so happy to have this eco-friendly, beautifully handwoven rug at the foot of our bed. And it feels so good on bare feet!\u201d',
    author: 'Shane A.',
  },
  {
    image: '/images/gallery/rugs/Rug254_KatieLintonskitchen.1_1400x1050.jpg',
    quote: '\u201cKathy spent time going through all of her color options to help me find just the rug I was looking for to use in my kitchen. It is beautiful and fits the space perfectly. I love it!\u201d',
    author: 'Katie L.',
  },
  {
    image: '/images/gallery/rugs/rug_fireplace.jpg',
    quote: '\u201cThis rug\u2019s colors harmonize beautifully with our large, cherry mantle. And on cold days, there\u2019s nothing better than to bury my toes in its warm, soft fabric.\u201d',
    author: 'Erin T.',
  },
];

function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [lightbox, setLightbox] = useState(null);
  const total = testimonials.length;

  const next = useCallback(() => setCurrent((c) => (c + 1) % total), [total]);
  const prev = useCallback(() => setCurrent((c) => (c - 1 + total) % total), [total]);

  const lbNext = useCallback(() => setLightbox((i) => (i + 1) % total), [total]);
  const lbPrev = useCallback(() => setLightbox((i) => (i - 1 + total) % total), [total]);
  const lbClose = useCallback(() => setLightbox(null), []);

  // Swipe support
  const [touchStart, setTouchStart] = useState(null);

  const handleTouchStart = (e) => setTouchStart(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? next() : prev();
    }
    setTouchStart(null);
  };

  // Keyboard nav for mobile slideshow
  useEffect(() => {
    if (lightbox !== null) return; // lightbox handles its own keys
    const handleKey = (e) => {
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [next, prev, lightbox]);

  // Keyboard nav + body scroll lock for lightbox
  useEffect(() => {
    if (lightbox === null) return;
    document.body.style.overflow = 'hidden';
    const handleKey = (e) => {
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowRight') lbNext();
      if (e.key === 'ArrowLeft') lbPrev();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [lightbox, lbClose, lbNext, lbPrev]);

  const t = testimonials[current];
  const lb = lightbox !== null ? testimonials[lightbox] : null;

  return (
    <section className="section testimonials" id="testimonials">
      <div className="section-header">
        <h2>Testimonials</h2>
        <div className="section-divider" />
        <p className="desktop-only">
          Handwoven rugs from Windy Hill Weavers are so versatile. Hang your rug on a wall
          or a rug ladder; toss it on the floor in front of your hearth; use it to cushion a
          bench or ottoman; or drape it across the foot of your bed. Click or hover over any
          photo to read what my customers have to say about their new rugs!
        </p>
        <p className="mobile-only">
          Handwoven rugs from Windy Hill Weavers are so versatile. Hang your rug on a wall
          or a rug ladder; toss it on the floor in front of your hearth; use it to cushion a
          bench or ottoman; or drape it across the foot of your bed. Click to read what my
          customers have to say about their new rugs!
        </p>
      </div>

      {/* Desktop: masonry grid with hover overlay + click to lightbox */}
      <div className="testimonials-grid">
        {testimonials.map((item, i) => (
          <div className="testimonial-card" key={i} onClick={() => setLightbox(i)}>
            <img src={item.image} alt={`Testimonial from ${item.author}`} loading="lazy" />
            <div className="testimonial-overlay">
              <div>
                <p dangerouslySetInnerHTML={{ __html: item.quote }} />
                <span className="testimonial-author">&mdash; {item.author}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop lightbox */}
      {lightbox !== null && (
        <div className="testimonial-lightbox" onClick={lbClose}>
          <button className="lightbox-close" onClick={lbClose} aria-label="Close">&times;</button>
          <button className="lightbox-prev" onClick={(e) => { e.stopPropagation(); lbPrev(); }} aria-label="Previous">&lsaquo;</button>
          <div className="testimonial-lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={lb.image} alt={`Testimonial from ${lb.author}`} />
            <div className="testimonial-lightbox-caption">
              <p dangerouslySetInnerHTML={{ __html: lb.quote }} />
              <span className="testimonial-lightbox-author">&mdash; {lb.author}</span>
            </div>
          </div>
          <button className="lightbox-next" onClick={(e) => { e.stopPropagation(); lbNext(); }} aria-label="Next">&rsaquo;</button>
          <div className="lightbox-counter">{lightbox + 1} / {total}</div>
        </div>
      )}

      {/* Mobile: slideshow with caption below */}
      <div
        className="testimonial-slideshow"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className="testimonial-slide">
          <img src={t.image} alt={`Testimonial from ${t.author}`} />
          <div className="testimonial-caption">
            <p dangerouslySetInnerHTML={{ __html: t.quote }} />
            <span className="testimonial-caption-author">&mdash; {t.author}</span>
          </div>
        </div>
        <div className="testimonial-nav">
          <button onClick={prev} aria-label="Previous testimonial">&lsaquo;</button>
          <span className="testimonial-counter">{current + 1} / {total}</span>
          <button onClick={next} aria-label="Next testimonial">&rsaquo;</button>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
